import React from "react";
import ContactImg from "../components/images/main1.png";

const Contact = () => {
  return (
    <section className="mt-[7rem] w-full pb-5" id="Contact">
      <div className="max-w-6xl  text-gray-400 px-4 mx-auto">
        <h1
          className="font-[200] text-[3rem] max-sm:text-[2rem] px-2 xl:text-left text-center mb-4"
          data-aos="slide-up"
          data-aos-duration="1000"
        >
          Contact me
        </h1>
        <div className="flex justify-center items-center">
          <form
            action="https://formsubmit.co/el/husaxu"
            method="POST"
            className="w-1/2 px-4 text-left max-lg:w-[40rem]"
            data-aos="flip-left"
            data-aos-duration="1000"
          >
            <input type="hidden" name="_captcha" value="false"></input>
            <div className="flex justify-between mb-2 lg:flex-row flex-col">
              <input
                type="text"
                name="name"
                className="bg-[transparent] h-[2.3rem] rounded-sm lg:w-[16rem] w-[100%] lg:mr-2 max-lg:mb-4"
                placeholder="Enter name..."
                required
              />
              <input
                type="text"
                name="email"
                className="bg-[transparent] h-[2.3rem] rounded-sm lg:w-[16rem] w-[100%] lg:ml-2 max-lg:mb-4"
                placeholder="Enter email..."
                required
              />
              <input
                type="hidden"
                name="_next"
                value="https://yourdomain.co/thanks.html"
              />
            </div>
            <textarea
              name="message"
              id=""
              cols="30"
              rows="10"
              className="w-full bg-[transparent] rounded-sm"
              placeholder="Enter message..."
              required
            ></textarea>
            <button
              className="bg-blue-700 py-1 px-5 text-white rounded-sm border-none font-[300] my-1 w-full text-[0.8rem]"
              type="submit"
            >
              SEND MESSAGE
            </button>
          </form>
          <div
            className="w-1/2 flex justify-center max-lg:hidden"
            data-aos="slide-right"
            data-aos-duration="1000"
          >
            <div className="bg-[#047] text-[#fff] h-[2rem] w-[12rem] flex justify-center items-center shadow-xl py-5 rounded-lg relative">
              Wanna drop a message?
              <div className="angle shadow-xl"></div>
            </div>
            <img src={ContactImg} alt="" className="h-[22rem]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
